import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../_redux/user-logs/UserLogsAction";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";

export function ExceptionModal({
  id,
  showExceptionModal,
  closeExceptionModal
}) {
  const [size, setSize] = useState();

  const dispatch = useDispatch();
  const { actionsLoading, exception } = useSelector(
    (state) => ({
      actionsLoading: state.userLogs.actionsLoading,
      exception: state.userLogs.exception
    }),
    shallowEqual
  );

  useEffect(() => {
    if (id) dispatch(actions.getException(id));
    return () => dispatch(actions.cleanExceptionState());
  }, [id, dispatch]);

  useEffect(() => {
    if (exception && exception.length > 500) setSize("lg");
    else setSize("sm");
  }, [exception]);

  return (
    <Modal
      size={size}
      show={showExceptionModal}
      onHide={closeExceptionModal}
      aria-labelledby="exception-title"
    >
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header className="justify-content-center">
        <Modal.Title id="exception-title">Hata</Modal.Title>
      </Modal.Header>
      {
        exception !== undefined &&
        <Modal.Body>
          <span style={{ wordWrap: "break-word"}}>
          {
            exception === null ? "Hata Bulunamadı!" : exception
          }
          </span>
        </Modal.Body>
      }      
      <Modal.Footer className="justify-content-center">
        <button
          type="button"
          className="btn btn-danger"
          onClick={closeExceptionModal}
        >
          Kapat
        </button>
      </Modal.Footer>
    </Modal>
  );
}